<template>
    <span v-if="hasPermission('stockmanagement.view')" v-bind="[$attrs]">
        <font-awesome-icon v-if="isLoading" icon="spinner" spin/>
        <span v-else-if="hasStock === true" class="text-success">
            op voorraad
        </span>
        <span v-else-if="hasStock === false" class="text-danger">
            geen voorraad
        </span>
        <b-button v-else size="sm" variant="link" class="m-o p-0 d-inline-block" @click="loadStockinfo" :disabled="!productIdentifier.trim().length">
            controleer voorraad
        </b-button>
    </span>
</template>

<script>
export default {
    name: 'ProductStockStatus',

    props: {
        productIdentifier: {required: true},
        quantity: {required: false, default: 1},
        autoCheck: {required: false, type: Boolean, default: false},
    },

    data() {
        return {
            isLoading: false,
            hasStock: null,
        }
    },

    mounted() {
        if (this.autoCheck) {
            this.loadStockinfo()
        }
    },

    methods: {
        loadStockinfo() {
            this.isLoading = true
            this.$http.get('/api/proxy/sle/api/stock/products/' + this.productIdentifier)
                .then(response => {
                    let remainingQuantity = this.quantity

                    this.hasStock = response.data.forEach(item => {
                        remainingQuantity -= item.stock_level
                    })

                    this.hasStock = remainingQuantity <= 0
                })
                .catch(e => {
                    this.$alert(`Fout bij het ophalen van voorraad voor product ${this.productIdentifier}`, 'danger')
                })
                .finally(() => this.isLoading = false)
        },
    },
}
</script>
